import React from 'react';

import { Button } from '@atoms';
import { showConfirm } from '@utils/modal';

import s from './styles.module.less';

export const ConfirmButton = ({ onOk, title, subtitle, text, ...props }) => (
  <Button
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    className={s.confirmButton}
    type="customBlue"
    onClick={(e) => {
      e.stopPropagation();
      showConfirm({
        okText: 'CONFIRM',
        onOk,
        title,
        content: subtitle,
      });
    }}
  >
    {text}
  </Button>
);

export default ConfirmButton;
